import type { LoginCompanySelection } from "@/interfaces/auth";
import type { User, UserInfo } from "@/interfaces/users";
import { httpService } from "./utils/http_service";
import axios from "axios";

export const authService = {
    getFirstAccess(token: string): Promise<User> {
        return httpService.get(`/public/auth/first-access/${token}`)
    },
    register(token: string, data: {}): Promise<string> {
        return httpService.post(`/public/auth/first-access/${token}`, data, { skipLoading: true })
    },
    login(vc_email: string, vc_senha: string): Promise<string | LoginCompanySelection> {
        return httpService.post(`/public/auth/login`, { vc_email, vc_senha }, { skipLoading: true })
    },
    selectCompany(pre_auth_token: string, id_empresa: string): Promise<string> {
        return httpService.post(`/public/auth/select-company`, { pre_auth_token, id_empresa }, { skipLoading: true })
    },
    async refreshToken(): Promise<string> {
        const res = await axios.get(`${import.meta.env.VITE_APP_URL}/public/auth/refresh-token`, {
            withCredentials: true // envia o cookie
        });
        return res.data.data
    },
    logout() {
        return httpService.get(`/public/auth/logout`)
    },
    userInfo(): Promise<UserInfo> {
        return httpService.get(`/users/info`)
    },
    switchCompany(id_empresa: string): Promise<string> {
        return httpService.post(`/auth/switch-company`, { id_empresa })
    },

    // Recuperação de senha
    recoverSendCode(vc_email: string): Promise<{ vc_hash: string }> {
        return httpService.post(`/public/auth/recover/send-code`, { vc_email }, { skipLoading: true });
    },
    recoverVerifyCode(vc_hash: string, vc_codigo: string) {
        return httpService.post(`/public/auth/recover/verify-code`, { vc_hash, vc_codigo }, { skipLoading: true });
    },
    recover(vc_hash: string, vc_codigo: string, vc_senha: string): Promise<string> {
        return httpService.post(`/public/auth/recover`, { vc_hash, vc_codigo, vc_senha }, { skipLoading: true });
    },
}